import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPharmacyActivities(id: string | undefined) {
  return useQuery(queries.pharmacies.getPharmacyActivitiesById(id || ''))
}
